/**
 * localStorage keys of the AI assistant chat (ChatContext) and who they belong to.
 *
 * The chat (messages, artifacts and the id of the server conversation being continued) is
 * kept per browser. It must never pass from one user to the next (#381): the next user would
 * see the previous chat and get 404 "Conversation not found" on every question.
 */
export const CHAT_STORAGE_KEYS = [
  'chatMessages',
  'chatArtifacts',
  'selectedArtifact',
  'showArtifacts',
  'conversationHistory',
  'aiConversationId',
];

const OWNER_KEY = 'chatOwner';

export const clearStoredChat = () => {
  CHAT_STORAGE_KEYS.forEach((k) => localStorage.removeItem(k));
  localStorage.removeItem(OWNER_KEY);
};

/**
 * Called on login: keep the stored chat only if it belongs to this user (e.g. same user
 * logging in again after the session expired), otherwise drop it.
 */
export const claimStoredChat = (userId) => {
  const owner = localStorage.getItem(OWNER_KEY);
  if (owner !== String(userId ?? '')) clearStoredChat();
  if (userId !== undefined && userId !== null) localStorage.setItem(OWNER_KEY, String(userId));
};
